import React, { useState } from 'react'
import contactImg from '../assets/conact.jpg'

const ways = [
  { icon: '🤲', title: 'Volunteer', desc: 'Give your time and skills. Join our network of 1,200+ volunteers working across all districts of Haryana.' },
  { icon: '💰', title: 'Donate', desc: 'Your financial contribution, big or small, directly funds education, healthcare, and welfare programmes.' },
  { icon: '📣', title: 'Spread the Word', desc: 'Share our mission with your network. Awareness is the first step towards meaningful change.' },
  { icon: '🏢', title: 'Corporate CSR', desc: 'Partner with us under your CSR mandate. We ensure transparent utilisation and proper 80G documentation.' },
]

export default function GetInvolved() {
  const [form, setForm] = useState({ name:'', phone:'', email:'', city:'', interest:'volunteer', message:'' })
  const [sent, setSent] = useState(false)
  const handle = e => setForm({ ...form, [e.target.name]: e.target.value })
  const submit = e => { e.preventDefault(); setSent(true) }

  return (
    <div>
      <div className="page-header">
        <div className="max-w-7xl mx-auto px-4">
          <h1>Get Involved</h1>
          <p className="breadcrumb">Home › Get Involved</p>
        </div>
      </div>

      {/* Ways to help */}
      <section className="py-16" style={{background:'white'}}>
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-12">
            <div className="section-tag" style={{justifyContent:'center'}}>Join the Mission</div>
            <h2 className="mb-3" style={{fontFamily:'Playfair Display,serif',fontSize:'clamp(26px,4vw,42px)',fontWeight:700,color:'var(--navy)'}}>
              How You Can Help
            </h2>
            <p style={{color:'var(--muted)',maxWidth:'520px',margin:'0 auto',lineHeight:1.8}}>
              There are many ways to contribute to Sewa Bharti Haryana's mission. Choose what works best for you.
            </p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
            {ways.map((w, i) => (
              <div key={i} className="rounded-2xl p-7 text-center transition-all hover:-translate-y-1"
                style={{background:'var(--cream)',border:'1px solid rgba(0,0,0,0.06)'}}>
                <div className="text-4xl mb-4">{w.icon}</div>
                <h3 className="font-bold mb-2 text-base" style={{color:'var(--navy)',fontFamily:'Playfair Display,serif'}}>{w.title}</h3>
                <p className="text-sm leading-relaxed" style={{color:'var(--muted)'}}>{w.desc}</p>
              </div>
            ))}
          </div>

          {/* Form + image */}
          <div className="rounded-3xl overflow-hidden flex flex-col lg:flex-row shadow-xl">
            <div className="lg:w-2/5 w-full">
              <img src={contactImg} alt="Get Involved" className="w-full h-full object-cover" style={{minHeight:'320px'}}/>
            </div>
            <div className="lg:w-3/5 w-full p-8 sm:p-12" style={{background:'white'}}>
              <div className="section-tag">Register Interest</div>
              <h3 className="mb-2 font-bold" style={{fontFamily:'Playfair Display,serif',fontSize:'clamp(22px,3vw,32px)',color:'var(--navy)'}}>
                Join Our Volunteer Network
              </h3>
              <p className="mb-7 text-sm leading-relaxed" style={{color:'var(--muted)'}}>
                Fill in your details and our team will connect with you about opportunities in your district.
              </p>

              {sent ? (
                <div className="text-center py-10">
                  <div className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4" style={{background:'rgba(232,103,10,0.1)'}}>
                    <svg className="w-8 h-8" fill="none" stroke="var(--saffron)" strokeWidth="2" viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12"/></svg>
                  </div>
                  <h4 className="font-bold text-xl mb-2" style={{color:'var(--navy)',fontFamily:'Playfair Display,serif'}}>Thank You for Stepping Forward!</h4>
                  <p style={{color:'var(--muted)'}}>Our team will reach out to you shortly. Together we'll make a difference.</p>
                </div>
              ) : (
                <form onSubmit={submit} className="space-y-4">
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <div>
                      <label className="block text-xs font-medium mb-1.5" style={{color:'var(--navy)'}}>Full Name *</label>
                      <input name="name" value={form.name} onChange={handle} placeholder="Your name" required className="sb-input"/>
                    </div>
                    <div>
                      <label className="block text-xs font-medium mb-1.5" style={{color:'var(--navy)'}}>Phone *</label>
                      <input name="phone" value={form.phone} onChange={handle} placeholder="Your number" required className="sb-input"/>
                    </div>
                    <div>
                      <label className="block text-xs font-medium mb-1.5" style={{color:'var(--navy)'}}>Email</label>
                      <input type="email" name="email" value={form.email} onChange={handle} placeholder="your@email.com" className="sb-input"/>
                    </div>
                    <div>
                      <label className="block text-xs font-medium mb-1.5" style={{color:'var(--navy)'}}>City / District</label>
                      <input name="city" value={form.city} onChange={handle} placeholder="Your city" className="sb-input"/>
                    </div>
                  </div>
                  <div>
                    <label className="block text-xs font-medium mb-1.5" style={{color:'var(--navy)'}}>Area of Interest</label>
                    <select name="interest" value={form.interest} onChange={handle} className="sb-input">
                      <option value="volunteer">Volunteer / Seva Karyakarta</option>
                      <option value="donate">Financial Donation</option>
                      <option value="csr">Corporate / CSR Partnership</option>
                      <option value="awareness">Awareness & Outreach</option>
                      <option value="medical">Medical / Health Services</option>
                      <option value="education">Education Support</option>
                    </select>
                  </div>
                  <div>
                    <label className="block text-xs font-medium mb-1.5" style={{color:'var(--navy)'}}>Message (Optional)</label>
                    <textarea name="message" value={form.message} onChange={handle} rows="3"
                      placeholder="Tell us anything additional about your interest or availability..."
                      className="sb-input" style={{resize:'vertical'}}/>
                  </div>
                  <button type="submit"
                    className="inline-flex items-center gap-2 text-white px-8 py-3.5 rounded-full font-semibold text-sm transition-all hover:-translate-y-0.5"
                    style={{background:'var(--saffron)',boxShadow:'0 6px 20px rgba(232,103,10,0.3)'}}>
                    Submit Application
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/></svg>
                  </button>
                </form>
              )}
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}
